module.exports = __webpack_public_path__ + "static/media/jangl-logo@3x.27d71169.png";